import { useTranslation } from 'react-i18next';
import type { Progresso } from '../types/Progresso';
import type { Acao } from './regrasDaFase';

/** Rótulo do botão de cada ação; o detalhe e o cartão do Início usam o mesmo (spec 29 R21). */
export function useRotuloDaAcao() {
  const { t } = useTranslation('campanhas');
  return (a: Acao, p: Progresso): string => {
    if (a === 'enviarNaoRecebidos')
      return t('acoes.enviarNaoRecebidos', { count: p.naoConvidados });
    if (a === 'lembrar') return t('acoes.lembrar', { count: p.naoResponderam });
    return t(`acoes.${a}`);
  };
}
